document.addEventListener('bundler:loaded', function (e) {
  window.bndlr.updateCartDiscounts();
});

// Listen to the custom event for recalculated cart values
document.addEventListener('bundler:total_cart_values', function (e) {
  // Extract the relevant values from the event detail with safe checks
  const {
    total_amount_original = 0,
    total_amount_discounted = 0,
    discount_amount = 0,
    discounted_cart_object = null,
  } = e.detail;

  console.log('total_amount_original', total_amount_original);
  console.log('total_amount_discounted', total_amount_discounted);
  console.log('discount_amount', discount_amount);
  console.log('discounted_cart_object', discounted_cart_object);
  
  // Get the base cart total (either from discounted amount or original attribute)
  const baseCartTotal = total_amount_discounted > 0 ? 
    total_amount_discounted : 
    (document.querySelector('cart-items').getAttribute('data-total-price'));

  // Update the cart subtotal (without VAT)
  const subtotalWithoutTaxElement = document.getElementById('cart-price_subtotal');
  const subtotalWithoutTax = (baseCartTotal / 1.07 / 100).toFixed(2).replace('.', ','); // Assume 7% VAT
  if (subtotalWithoutTaxElement) {
    subtotalWithoutTaxElement.textContent = `${subtotalWithoutTax} €`;
  }

  // Update the total tax element
  const totalTaxElement = document.getElementById('cart-price_tax');
  const totalTax = (baseCartTotal / 100 - baseCartTotal / 1.07 / 100).toFixed(2).replace('.', ','); // Correct VAT calculation
  if (totalTaxElement) {
    totalTaxElement.textContent = `${totalTax} €`;
  } else {
    totalTaxElement.textContent = `0,00 €`; // Fallback if calculation fails
  }

  // Update the total discount element
  const totalDiscountElement = document.getElementById('cart-price_discount');
  const totalDiscount = (discount_amount / 100).toFixed(2).replace('.', ',');
  if (totalDiscountElement) {
    totalDiscountElement.textContent = `-${totalDiscount} €`;
  }

  console.log('totalDiscount', discount_amount);
  if (discount_amount > 0) {
    document.querySelectorAll('[data-cart-discount').forEach((e) => {
      e.classList.add('flex');
      e.classList.remove('hidden');
      console.log(e);
    });
  } else {
    document.querySelectorAll('[data-cart-discount').forEach((e) => {
      console.log(e);
      e.classList.remove('flex');
      e.classList.add('hidden');
      console.log(e);
    });
  }

  // Update the shipping progress bar and text
  const shippingThreshold = 1500; // 1500 euros free shipping threshold
  const currentCartTotal = baseCartTotal / 100; // Convert cents to euros
  const progressBarElement = document.getElementById('shipping-progress-bar');
  const shippingMessageElement = document.getElementById('shipping-message');
  const shippingCostElement = document.getElementById('cart-shipping_amount');
  const shippingCostElementContainer = document.getElementById('cart-shipping_amount-container');
  const hiddenShippingPriceElement = document.getElementById('hidden-shipping-price');

  const checkoutButton = document.querySelector(`.cart__checkout-button`);

  console.log('ship');
  console.log(shippingMessageElement);

  if (progressBarElement) {
    const progressPercentage = Math.min((currentCartTotal / shippingThreshold) * 100, 100);
    progressBarElement.style.width = `${progressPercentage}%`;
  }

  // Get shipping cost from the hidden element
  let shippingCost = 0;
  if (hiddenShippingPriceElement) {
    const shippingPriceText = hiddenShippingPriceElement.getAttribute('data-shipping-price');
    // Parse the shipping price (assuming format like "4,95 €")
    shippingCost = parseFloat(shippingPriceText.replace('€', '').replace(',', '.').trim());
    console.log('Parsed shipping cost:', shippingCost);
  }

  // Determine if shipping is free
  const isShippingFree = currentCartTotal >= shippingThreshold;
  console.log('Current cart total:', currentCartTotal, 'Threshold:', shippingThreshold, 'Is shipping free:', isShippingFree);

  // Calculate final total INCLUDING shipping when applicable
  let finalTotal = currentCartTotal;
  if (!isShippingFree) {
    finalTotal += shippingCost;
    console.log('Adding shipping cost to total. New total:', finalTotal);
  }

  if (currentCartTotal < shippingThreshold) {
    console.log('currentCartTotal', currentCartTotal);
    console.log('shippingThreshold', shippingThreshold);
    const amountLeft = (shippingThreshold - currentCartTotal).toFixed(2).replace('.', ',');
    
    // Updated message to focus on free shipping rather than order completion
    shippingMessageElement.innerHTML = `Fügen Sie Artikel im Wert von 
        <span class="font-bold" id="shipping-threshold-left">
        ${amountLeft} €
        </span>
        hinzu, um <span class="font-bold text-accent">kostenlosen Versand</span> zu erhalten!`;
        
    if (shippingCostElement) {
      console.log('shippingCostElement', shippingCostElement);
      shippingCostElementContainer.classList.remove('hidden');
      // Get shipping price from hidden element
      shippingCostElement.textContent = hiddenShippingPriceElement.getAttribute('data-shipping-price');
      console.log('Setting shipping cost display to:', hiddenShippingPriceElement.getAttribute('data-shipping-price'));
    }

    // Remove disabled button functionality - allow checkout at any cart value
    checkoutButton.classList.remove('disabled-link');
    checkoutButton.innerHTML = `Weiter zur Bestellung`;
  } else {
    shippingMessageElement.innerHTML = `Sie haben <span class="font-bold text-accent">kostenlosen</span> Versand erreicht!`;
    if (shippingCostElement) {
      shippingCostElementContainer.classList.remove('hidden');
      shippingCostElement.textContent = 'Gratis';
      console.log('Setting shipping to Gratis because cart total >= threshold');
    }

    checkoutButton.classList.remove('disabled-link');
    checkoutButton.innerHTML = `Weiter zur Bestellung`;
  }

  // Update the total price element WITH shipping included when applicable
  const totalPriceElement = document.getElementById('cart-price_total');
  const totalPriceFormatted = finalTotal.toFixed(2).replace('.', ',');
  if (totalPriceElement) {
    totalPriceElement.textContent = `${totalPriceFormatted} €`;
    console.log('Setting final total display to:', totalPriceFormatted);
  }

  // Update individual cart items
  if (discounted_cart_object && discounted_cart_object.items) {
    discounted_cart_object.items.forEach((item) => {
      console.log(item);
      // Find the relevant cart item element by its variant ID or another unique identifier
      const itemElement = document.querySelector(`[data-cart-variant="${item.variant_id}"]`);

      let variant;
      fetch(`/products/${item.handle}.js`)
        .then((response) => response.json())
        .then((product) => {
          variant = product.variants.filter((v) => v.title == item.variant_title)[0];
          console.log('pvariant', variant);
        });

      if (itemElement) {
        // Update the original price display
        const oldPriceElement = itemElement.querySelector('[data-old-price]');
        if (oldPriceElement) {
          oldPriceElement.textContent = `${((variant.compare_at_price * item.quantity) / 100)
            .toFixed(2)
            .replace('.', ',')} €`;
        }
        // Update the new price display
        const newPriceElement = itemElement.querySelector('[data-new-price]');
        if (newPriceElement) {
          newPriceElement.textContent = `${(item.line_price / 100).toFixed(2).replace('.', ',')} €`;
        }

        if (!oldPriceElement) return false;

        if (variant && variant.compare_at_price * item.quantity > item.line_price) {
          oldPriceElement.style.display = 'block';
        } else {
          oldPriceElement.style.display = 'none';
        }
      } else {
        console.warn(`Cart item element not found for variant ID: ${item.variant_id}`);
      }
    });
  } else {
    console.warn('Discounted cart object is undefined or missing items.');
  }
});

// Dispatch initial event to initialize cart values
var cartEvent = new CustomEvent('bundler:total_cart_values', {
  detail: {
    total_amount_original: 0, // Initialize with default or dummy value
  },
});
document.dispatchEvent(cartEvent);

function increaseQuantity(event, id) {
  event.preventDefault();
  console.log('increase quantity', id);

  document.querySelector(`quantity-input[id="Quantity-${id}"] .quantity__button[name="plus"]`).click();
}
function decreaseQuantity(event, id) {
  event.preventDefault();
  console.log('decrease quantity', id);

  document.querySelector(`quantity-input[id="Quantity-${id}"] .quantity__button[name="minus"]`).click();
}